
/**
 * Scrolls the nearest scrollable parent element to the specified position
 */
const scrollNearestParent = (
  element: HTMLElement,
  scrollOptions: ScrollToOptions = { top: 0, behavior: "smooth" }
) => {
  let currentElement = element.parentElement
  while (currentElement) {
    const hasScroll =
      currentElement.scrollTop > 0 ||
      currentElement.scrollHeight > currentElement.clientHeight ||
      getComputedStyle(currentElement).overflowY === "auto" ||
      getComputedStyle(currentElement).overflowY === "scroll"

    if (hasScroll) {
      currentElement.scrollTo(scrollOptions)
      return
    }
    currentElement = currentElement.parentElement
  }

  // Fallback to window scroll if no scrollable container found
  window.scrollTo(scrollOptions)
}

export default scrollNearestParent
